import React from 'react'

// Basic Detail Section
const BasicDetail = ({data,pageJson,translations,countryList,getCountryTaxonomy}) => {
    if(pageJson !== undefined){
      return(
  <div className="cc-detail-container clearfix">
    <div className="cc-detail-container__heading">{`1. ${translations(pageJson.pageHeading)}`}</div>
    <div className="cc-detail-container__content">
      <dl className="cc-detail-container__horizontal-row">
      <dt>{translations(pageJson.selectAgent)}:</dt>
      <dd>{data.glsAgent !== undefined ? data.glsAgent.name : ''}</dd>
      <dt>{translations(pageJson.productType)}:</dt>
      <dd>{data.glsProductType !== undefined ? data.glsProductType.name : ''}</dd>
      <dt>Relationship Bank of GLS Product:</dt>
      <dd>{data.relationshipBank !== undefined ? countryList !==undefined? getCountryTaxonomy(data.relationshipBank).name :data.relationshipBank.name : ''}</dd>
      <dt>{translations(pageJson.cashConTitle)}:</dt>
      <dd>{data.cashConTitle !== undefined && data.cashConTitle !== '' ? data.cashConTitle : ''}</dd>
      </dl>
    </div>
  </div>
)
}else {
  return ''
}
}

export default BasicDetail;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/BasicDetail.js